import Mailcheck from 'mailcheck'
import Swiper from 'swiper'
import { EffectFade, Mousewheel, Navigation, Thumbs } from 'swiper/modules'
import handleAjaxAddToCart from './ajax-add-to-cart'
import orderAttribution from './order-attribution.ts'

declare global {
	interface Window {
		jQuery: any
		$: any
	}
}

const $ = window.jQuery || window.$

export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		function handleProductMiniatureVariationClick(el: Element) {
			const variantId = parseInt(el.getAttribute('data-variant-id') ?? 0)
			if (variantId === 0) return

			const productEl = el.closest('.product-miniature')
			if (!productEl) return

			const productData = JSON.parse(atob(productEl.getAttribute('data-product') ?? ''))
			const variant = productData.variations.find((v) => v.variation_id === variantId)

			const imgEls = productEl.querySelectorAll('.product-miniature-img')
			const badgesEls = productEl.querySelectorAll('.product-miniature-badges')
			const priceEls = productEl.querySelectorAll('.product-miniature-price')
			const activeVariationEls = productEl.querySelectorAll(
				'.product-miniature-add-to-cart-variation.active',
			)
			const omnibusEls = productEl.querySelectorAll('.product-miniature-omnibus')
			const submitEls = productEl.querySelectorAll('.product-miniature-add-to-cart-submit')
			if (
				imgEls.length === 0 ||
				badgesEls.length === 0 ||
				priceEls.length === 0 ||
				activeVariationEls.length === 0 ||
				omnibusEls.length === 0 ||
				submitEls.length === 0
			)
				return

			const is_on_sale = variant.display_price !== variant.display_regular_price

			// change price
			priceEls.forEach((priceEl) => {
				priceEl.innerHTML = `${is_on_sale ? `<div class="product-miniature-price-old">${variant.display_regular_price_html}</div>` : ''}<div class="product-miniature-price-current">${variant.display_price_html}</div>`
			})

			// change image
			imgEls.forEach((imgEl) => {
				imgEl.setAttribute('style', `--img: url(${variant.image.url})`)
			})

			// change omnibus
			omnibusEls.forEach((omnibusEl) => {
				omnibusEl.innerHTML = is_on_sale ? variant.omnibus : ''
			})

			// change add to cart
			submitEls.forEach((submitEl) => {
				submitEl.setAttribute('href', `/?add-to-cart=${variantId}&quantity=1`)
			})

			// change badges
			badgesEls.forEach((badgesEl) => {
				badgesEl.innerHTML = `${variant.discount_percentage !== 0 ? `<div class="product-miniature-badges-item">-${variant.discount_percentage}%</div>` : ''}`
			})

			activeVariationEls.forEach((activeVariationEl) => {
				activeVariationEl.classList.remove('active')
			})

			el.classList.add('active')
			console.log(productData)
		}

		const productMiniatureVariationEls = document.querySelectorAll(
			'.product-miniature-add-to-cart-variation',
		)
		if (productMiniatureVariationEls) {
			productMiniatureVariationEls.forEach((productMiniatureVariationEl) => {
				productMiniatureVariationEl.addEventListener('click', function () {
					handleProductMiniatureVariationClick(productMiniatureVariationEl)
				})
			})
		}
	})

	document.addEventListener('DOMContentLoaded', function () {
		const stickyHeaderEl = document.getElementById('sticky-header')

		const filtersDrawerEls = document.querySelectorAll('.product-category-mobile-filters-drawer')
		const filtersDrawerBgEls = document.querySelectorAll(
			'.product-category-mobile-filters-drawer-bg',
		)

		function toggleProductCategoryMobileFiltersDrawer() {
			if (stickyHeaderEl) {
				stickyHeaderEl.classList.remove('active')
			}
			document.body.classList.remove('has-sticky-header')
			document.body.classList.toggle('modal-active')
			if (filtersDrawerBgEls) {
				filtersDrawerBgEls.forEach(function (filtersDrawerBgEl) {
					filtersDrawerBgEl.classList.toggle('open')
				})
			}
			if (filtersDrawerEls) {
				filtersDrawerEls.forEach(function (filtersDrawerEl) {
					filtersDrawerEl.classList.toggle('open')
				})
			}
		}

		const triggerEls = document.querySelectorAll('.product-category-mobile-filters-trigger')
		if (triggerEls) {
			triggerEls.forEach(function (triggerEl) {
				triggerEl.addEventListener('click', function () {
					toggleProductCategoryMobileFiltersDrawer()
				})
			})
		}

		const applyEls = document.querySelectorAll('.product-category-mobile-filters-apply')
		if (applyEls) {
			applyEls.forEach(function (applyEl) {
				applyEl.addEventListener('click', function () {
					const drawerEl = applyEl.closest('.product-category-mobile-filters-drawer')
					if (!drawerEl) return
					const submitEl = drawerEl.querySelector('.wpc-filters-submit-button')
					if (submitEl) {
						submitEl.click()
					}
				})
			})
		}

		const closeEls = document.querySelectorAll('.product-category-mobile-filters-close')
		if (closeEls) {
			closeEls.forEach(function (closeEl) {
				closeEl.addEventListener('click', function () {
					toggleProductCategoryMobileFiltersDrawer()
				})
			})
		}
	})

	jQuery(document).ready(function ($) {
		const isCartPage = $('body').hasClass('woocommerce-cart')
		const isCheckoutPage = $('body').hasClass('woocommerce-checkout')

		const woocommerce = $('.woocommerce-wizard')

		function recalculateCart() {
			const disabled = $('[name="update_cart"]').is(':disabled')
			if (disabled) {
				$('[name="update_cart"]').prop('disabled', false)
			}
			$('[name="update_cart"]').trigger('click')
			if (disabled) {
				$('[name="update_cart"]').prop('disabled', true)
			}
		}

		function submitCheckout() {
			$('#place_order').trigger('click')
		}

		if (isCartPage) {
			woocommerce.on('change', 'input.qty', function () {
				recalculateCart()
			})
		} else {
			woocommerce.on('click', '.woocommerce-wizard-sidebar-summary-place-order', function () {
				submitCheckout()
			})
		}

		$(document.body).on('applied_coupon_in_checkout', function () {
			setTimeout(function () {
				$('.woocommerce-wizard-sidebar-coupon .woocommerce-message').detach()
			}, 200)

			$('.coupon-error-notice:not(:last)').detach()

			if (isCartPage) {
				$.ajax({
					url: '/?wc-ajax=get_refreshed_fragments&source=cart',
					type: 'POST',
					dataType: 'json',
					success: function (response) {
						if (
							response &&
							response.fragments &&
							response.fragments['.woocommerce-wizard-sidebar-summary']
						) {
							$('.woocommerce-wizard-sidebar-summary').replaceWith(
								response.fragments['.woocommerce-wizard-sidebar-summary'],
							)
						}
					},
				})
			}
		})

		$(document).on('removed_coupon_in_checkout', function () {
			$('.coupon-error-notice').detach()
		})

		woocommerce.on('click', '.js-woocommerce-wizard-sidebar-card-header-toggle', function () {
			$(this).closest('.woocommerce-wizard-sidebar-card').toggleClass('collapsed')
		})
	})

	document.addEventListener('DOMContentLoaded', function () {
		if (document.body.classList.contains('single-product')) {
			let singleProductGalleryEl = document.querySelector('.single-product .single-product-gallery')
			if (!singleProductGalleryEl) return

			const singleProductGalleryThumbsEl = singleProductGalleryEl.querySelector(
				'.single-product-gallery-thumbs',
			)
			if (!singleProductGalleryThumbsEl) {
				console.warn('singleProductGalleryThumbsEl not found')
				return
			}

			const singleProductGalleryMainEl = singleProductGalleryEl.querySelector(
				'.single-product-gallery-main',
			)
			if (!singleProductGalleryMainEl) {
				console.warn('singleProductGalleryMainEl not found')
				return
			}

			const singleProductGalleryMobileEl = singleProductGalleryEl.querySelector(
				'.single-product-gallery-mobile',
			)
			if (!singleProductGalleryMobileEl) {
				console.warn('singleProductGalleryMobileEl not found')
				return
			}

			const singleProductGalleryThumbsSlider = new Swiper(
				singleProductGalleryThumbsEl as HTMLElement,
				{
					loop: true,
					spaceBetween: 20,
					slidesPerView: 3,
					freeMode: true,
					watchSlidesProgress: true,
				},
			)

			new Swiper(singleProductGalleryMainEl as HTMLElement, {
				modules: [Navigation, Mousewheel, Thumbs, EffectFade],
				loop: true,
				effect: 'fade',
				spaceBetween: 20,
				navigation: {
					prevEl: singleProductGalleryEl.querySelector(
						'.single-product-gallery-thumbs-nav-prev',
					) as HTMLElement,
					nextEl: singleProductGalleryEl.querySelector(
						'.single-product-gallery-thumbs-nav-next',
					) as HTMLElement,
				},
				thumbs: {
					swiper: singleProductGalleryThumbsSlider,
				},
			})

			new Swiper(singleProductGalleryMobileEl as HTMLElement, {
				modules: [Navigation, Mousewheel],
				effect: 'slide',
				slidesPerView: 1.1,
				spaceBetween: 20,
			})
		}
	})

	jQuery(document).ready(function ($) {
		const isCartPage = $('body').hasClass('woocommerce-cart')

		if ($('.single-product-variations-radio-input').length > 0) {
			const singleProductVariationsSelect = $('.single-product-variations-hidden-select')
			$(
				`.single-product-variations-radio-input[value="${singleProductVariationsSelect.find(':selected').val()}"]`,
			).prop('checked', true)
		}

		$('.single-product-variations-radio-input').on('change', function () {
			const attr_name = $(this).attr('name')
			const value = $(this).attr('value')

			$(this)
				.closest('.single-product-variations')
				.find(`.single-product-variations-hidden-select`)
				.val(value)
				.trigger('change', {})
		})

		$('.single-product-variations .select2').select2({
			minimumResultsForSearch: -1,
		})

		function setupQuantityEvents() {
			$('.product-quantity-minus').on('click', function () {
				const parent = $(this).parent('.quantity')
				const input = parent.find('.qty')
				const inputMin = input.prop('min')
				const currentValue = parseFloat(input.val())
				if (currentValue + 1 > (inputMin ? parseFloat(inputMin) : 2)) {
					input.val(currentValue - 1)
					input.trigger('change')
				}
			})

			$('.product-quantity-plus').on('click', function () {
				const parent = $(this).parent('.quantity')
				const input = $(parent).find('.qty')
				const inputMax = input.prop('max')
				const currentValue = parseFloat(input.val())
				if (inputMax ? currentValue < parseFloat(inputMax) : true) {
					input.val(currentValue + 1)
					input.trigger('change')
				}
			})
		}

		if (isCartPage) {
			$(document.body).on('updated_cart_totals', function () {
				setupQuantityEvents()
			})
		}

		setupQuantityEvents()
	})

	document.addEventListener('DOMContentLoaded', function () {
		const bestBeforeBtnEls = document.querySelectorAll('.single-product a[href="#best-before"]')
		if (bestBeforeBtnEls) {
			bestBeforeBtnEls.forEach((bestBeforeBtnEl) => {
				bestBeforeBtnEl.addEventListener('click', function () {
					const bestBeforeTabEl = document.querySelector(
						'.single-product-tabs-sidebar-item[data-tab="best-before"]',
					)
					const bestBeforeTabContentEl = document.querySelector(
						'.single-product-tabs-contents-item[data-tab="best-before"]',
					)
					const activeTabEl = document.querySelector('.single-product-tabs-sidebar-item.active')
					const activeTabContentEl = document.querySelector(
						'.single-product-tabs-contents-item.active',
					)
					const activeMobileTabEl = document.querySelector(
						'.single-product-mobile-tabs-item.active',
					)
					const bestBeforeMobileTabEl = document.querySelector(
						'.single-product-mobile-tabs-item[data-tab="best-before"]',
					)

					if (activeTabEl && activeTabContentEl) {
						activeTabEl.classList.remove('active')
						activeTabContentEl.classList.remove('active')
					}
					if (activeMobileTabEl) {
						activeMobileTabEl.classList.remove('active')
					}

					if (bestBeforeTabEl && bestBeforeTabContentEl) {
						bestBeforeTabEl.classList.add('active')
						bestBeforeTabContentEl.classList.add('active')
					}
					if (bestBeforeMobileTabEl) {
						bestBeforeMobileTabEl.classList.add('active')
					}

					document.getElementById('tabs')?.scrollIntoView()
				})
			})
		}

		const singleProductTabsSidebarItemEls = document.querySelectorAll(
			'.single-product-tabs-sidebar-item',
		)
		if (singleProductTabsSidebarItemEls) {
			singleProductTabsSidebarItemEls.forEach((singleProductTabsSidebarItemEl) => {
				singleProductTabsSidebarItemEl.addEventListener('click', function () {
					const tab = singleProductTabsSidebarItemEl.getAttribute('data-tab')
					const targetContentsItem = document.querySelector(
						`.single-product-tabs-contents-item[data-tab="${tab}"]`,
					)

					const currentActiveSidebarItem = document.querySelector(
						'.single-product-tabs-sidebar-item.active',
					)
					if (currentActiveSidebarItem) {
						currentActiveSidebarItem.classList.remove('active')
					}

					const currentActiveContentsItem = document.querySelector(
						'.single-product-tabs-contents-item.active',
					)
					if (currentActiveContentsItem) {
						currentActiveContentsItem.classList.remove('active')
					}

					singleProductTabsSidebarItemEl.classList.add('active')
					if (targetContentsItem) {
						targetContentsItem.classList.add('active')
					}
				})
			})
		}

		const singleProductMobileTabsItemHeaderEls = document.querySelectorAll(
			'.single-product-mobile-tabs-item-header',
		)
		if (singleProductMobileTabsItemHeaderEls) {
			singleProductMobileTabsItemHeaderEls.forEach((singleProductMobileTabsItemHeaderEl) => {
				singleProductMobileTabsItemHeaderEl.addEventListener('click', function () {
					const parentEl = singleProductMobileTabsItemHeaderEl.closest(
						'.single-product-mobile-tabs-item',
					)
					if (parentEl) {
						parentEl.classList.toggle('active')
					}
				})
			})
		}

		const singleProductStarsSeeEl = document.querySelector('.single-product-stars-see')
		if (singleProductStarsSeeEl) {
			singleProductStarsSeeEl.addEventListener('click', function () {
				const reviewsTabEl = document.querySelector(
					'.single-product-tabs-sidebar-item[data-tab="reviews"]',
				)
				const reviewsTabContentEl = document.querySelector(
					'.single-product-tabs-contents-item[data-tab="reviews"]',
				)
				const activeTabEl = document.querySelector('.single-product-tabs-sidebar-item.active')
				const activeTabContentEl = document.querySelector(
					'.single-product-tabs-contents-item.active',
				)
				const activeMobileTabEl = document.querySelector('.single-product-mobile-tabs-item.active')
				const reviewsMobileTabEl = document.querySelector(
					'.single-product-mobile-tabs-item[data-tab="reviews"]',
				)

				if (activeTabEl && activeTabContentEl) {
					activeTabEl.classList.remove('active')
					activeTabContentEl.classList.remove('active')
				}
				if (activeMobileTabEl) {
					activeMobileTabEl.classList.remove('active')
				}

				if (reviewsTabEl && reviewsTabContentEl) {
					reviewsTabEl.classList.add('active')
					reviewsTabContentEl.classList.add('active')
				}
				if (reviewsMobileTabEl) {
					reviewsMobileTabEl.classList.add('active')
				}

				document.getElementById('tabs')?.scrollIntoView()
			})
		}
		handleQuantityInputOnProductPage(jQuery)

		handleAjaxAddToCart()
	})

	function handleQuantityInputOnProductPage($) {
		const $variationForm = $('form.variations_form')

		if (!$variationForm.length) return

		function getVariationData(variationId: number) {
			const $variations = $('.variations_form').attr('data-product_variations') ?? '[]'
			const $variationsArray = JSON.parse($variations) ?? []
			const variation = $variationsArray.find(
				(item: { variation_id: number }) => item.variation_id === variationId,
			)
			return variation ?? null
		}

		function fillInputWithVariationData(
			$data: {
				min_qty: number
				max_qty: number
				is_in_stock: boolean
			} | null,
		) {
			if (!$data) return

			const { min_qty, max_qty, is_in_stock } = $data
			const $qtyInput = $('.product-quantity-input')

			if (!$qtyInput.length) return

			$qtyInput.prop('min', min_qty)
			$qtyInput.prop('max', max_qty)
			$qtyInput.val(Math.max(min_qty, 1))
			$qtyInput.prop('disabled', !is_in_stock)
			$qtyInput.prop('readonly', !is_in_stock)
			$qtyInput.prop('type', is_in_stock ? 'number' : 'hidden')
			$qtyInput.trigger('change')
		}

		function resetQtyInput() {
			const $qtyInput = $('.product-quantity-input')
			if (!$qtyInput.length) return

			$qtyInput.prop('min', 1)
			$qtyInput.prop('max', 1)
			$qtyInput.val(1)
			$qtyInput.prop('disabled', true)
			$qtyInput.prop('readonly', true)
			$qtyInput.prop('type', 'hidden')
			$qtyInput.trigger('change')
		}

		$variationForm.on('woocommerce_variation_has_changed', function (e) {
			const $variationId = String($('input[name="variation_id"]').val() ?? '0')
			const variationId = parseInt($variationId)
			if (!variationId) {
				$('.product-quantity.quantity').hide()
				resetQtyInput()
				return
			}
			const variation = getVariationData(variationId)

			if (variation && variation.is_in_stock) {
				$('.product-quantity.quantity').show()
				fillInputWithVariationData(variation)
			} else {
				$('.product-quantity.quantity').hide()
				resetQtyInput()
			}
		})

		$variationForm.on('reset_data', function () {
			$('.product-quantity.quantity').hide()
			resetQtyInput()
		})
	}

	function handleEmailSuggestionsInCheckout($: any) {
		const config = {
			topLevelDomains: ['com', 'pl'],
			secondLevelDomains: ['gmail', 'wp', 'onet', 'icloud', 'o2'],
			suggested: (suggestion: any) => {
				displaySuggestionInfo(
					$emailInput.closest('.form-row'),
					`Czy chodziło Ci o <button class="suggested-email" id="suggested-email" type="button" style="text-decoration: underline; cursor: pointer;color: var(--color-green-04)">${suggestion.full}</button>?`,
				)
			},
			empty: () => {
				$('.suggestion-info').remove()
			},
		}
		const $emailInput = $('#billing_email')

		if (!$emailInput.length) return

		$emailInput.on('change', function () {
			const email = $emailInput.val()
			if (!email) return
			Mailcheck.run({ ...config, email: email })
		})
	}

	function displaySuggestionInfo($el: any, message: string) {
		$('.suggestion-info').remove()

		const $tooltip = $(
			'<div class="suggestion-info" style="padding-top: 4px; font-size: 14px;"></div>',
		)
		$tooltip.html(message)
		$el.append($tooltip)
	}

	function handleSuggestedEmailClick($: any) {
		$(document).on('click', '#suggested-email', function (e: any) {
			e.preventDefault()
			const suggestedEmail = $(this).text()
			$('#billing_email').val(suggestedEmail)
			$('.suggestion-info').remove()
		})
	}

	function handleCheckoutScrollToPaymentMethod($: any) {
		if (!$('body').hasClass('woocommerce-checkout')) return

		let hasInitialized = false
		$(document.body).on('payment_method_selected', function () {
			if (!hasInitialized) {
				hasInitialized = true
				return
			}

			setTimeout(() => {
				const $selected = $('.woocommerce-checkout input[name="payment_method"]:checked')

				if ($selected.length) {
					const elementTop = $selected.offset().top
					const offset = 150

					$('html, body').animate(
						{
							scrollTop: elementTop - offset,
						},
						300,
					)
				}
			}, 500)
		})
	}

	function determineLayoutForVariantSelectors($: JQueryStatic) {
		const variantRadios = document.querySelectorAll('.single-product-variations-radio')
		if (variantRadios.length === 0 || !variantRadios) return
		const hasTextLongerThan6Chars = Array.from(variantRadios).some(
			(item: any) => item.textContent?.trim().length > 6,
		)

		if (hasTextLongerThan6Chars) {
			$('.single-product-variations').addClass('single-product-variations-radio-large')
		}
	}

	function handleVariatnSelectorEqualHeight($: JQueryStatic) {
		const variantRadios = document.querySelectorAll('.single-product-variations-radio')
		if (variantRadios.length === 0 || !variantRadios) return
		let elementWithMaxHeight = null
		let maxHeight = 0

		variantRadios.forEach((item: any) => {
			const height = item.offsetHeight
			if (height > maxHeight) {
				maxHeight = height
				elementWithMaxHeight = item
			}
		})

		variantRadios.forEach((item: any) => {
			item.style.height = `${maxHeight}px`
		})
	}

	function handleVariationPriceHint($: JQueryStatic) {
		const $variationPriceHint = $('.variation-price-hint')
		if (!$variationPriceHint.length) return
		if ($variationPriceHint.css('display') === 'none') return
		$variationPriceHint.css('display', 'none')
	}

	function handleNipFieldLabelChangeInCheckout($: JQueryStatic) {
		if (!$('body').hasClass('woocommerce-checkout')) return

		const $billingInvoiceType = $('#billing_invoice_type')
		const INVOICE_TYPES = {
			personal: 'typ1',
			company: 'typ2',
		}

		$billingInvoiceType.on('change', function (e) {
			const $billingInvoiceNip = $('#billing_invoice_nip')
			if ($(this).val() === INVOICE_TYPES.company) {
				$billingInvoiceNip.attr('placeholder', 'NIP')
			}
			if ($(this).val() === INVOICE_TYPES.personal) {
				$billingInvoiceNip.attr('placeholder', 'NIP (opcjonalnie)')
			}
		})
	}

	function updateProductsFoundOnListingPage($: JQueryStatic) {
		const $productsFound = $('#fe-posts-found-template')
		const $productCategoryTotal = $('.product-category-total')
		if (!$productsFound.length || !$productCategoryTotal.length) return

		$productCategoryTotal.html($productsFound.html())
	}

	function observePostsTemplateChanges(callback) {
		const createMutationObserver = (targetSelector, callback): void => {
			const targetElement = document.querySelector(targetSelector)

			if (!targetElement) {
				console.warn(`[Observer] Element not found: ${targetSelector}`)
				return
			}

			const observer = new MutationObserver((mutations) => {
				for (const mutation of mutations) {
					if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
						callback(mutation.addedNodes)
					}
				}
			})

			observer.observe(targetElement, {
				childList: true,
				subtree: true,
			})
		}
		console.log('observePostsTemplateChanges')

		createMutationObserver('.product-category-products .products-items', (mutation) => {
			console.log('mutation', mutation)
			if (mutation.length === 0) return
			if ([...mutation].some((node: any) => node.id === 'fe-posts-found-template')) {
				updateProductsFoundOnListingPage($)
			}
		})
	}

	function toggleOptionalBundleItem() {
		const $input = $(this)
		const is_checked = $input.is(':checked')
		const $content = $input.parent().find('.bundled_item_cart_content')
		if (is_checked) {
			$content.show()
		} else {
			$content.hide()
		}
	}

	function syncProductTabs() {
		const mobileBreakpoint = 1024

		function moveTabContent() {
			const screenWidth = window.innerWidth
			const isMobile = screenWidth < mobileBreakpoint

			$('.single-product-tabs-contents-item').each(function () {
				const $desktopTab = $(this)
				const tabKey = $desktopTab.data('tab')
				const $desktopContent = $desktopTab.find('.single-product-tabs-contents-item-content')
				const $mobileContent = $(
					'.single-product-mobile-tabs-item[data-tab="' + tabKey + '"]',
				).find('.single-product-mobile-tabs-item-content')

				if (isMobile) {
					if ($desktopContent.children().length) {
						$desktopContent.children().appendTo($mobileContent)
					}
				} else {
					if ($mobileContent.children().length) {
						$mobileContent.children().appendTo($desktopContent)
					}
				}
			})
		}

		moveTabContent()

		$(window).on('resize orientationchange', function () {
			moveTabContent()
		})
	}

	function adjustPaczkomatSelectorPosition() {
		const $wrapper = $('.paczkomat_id_wrapper')
		$wrapper.closest('li.shipping_method').append($wrapper)
		$wrapper.addClass('show')
	}

	function adjustDPDPickupPointSelectorPosition() {
		const $wrapper = $('#dpd-pickup-point-wrapper')
		if (!$wrapper.length) return

		const $checkedShipping = $('input[name^="shipping_method"]:checked')
		if (!$checkedShipping.length) return

		$checkedShipping.closest('li.shipping_method').append($wrapper)
		$wrapper.addClass('show')
	}

	function truncateText(text, maxLength = 20) {
		if (text.length > maxLength) {
			return text.substring(0, maxLength) + '...'
		}
		return text
	}

	function initSelect2Truncate() {
		const $select = $('select#paczkomat_id')
		$select.on('select2:select', function (e) {
			const selectedText = e.params.data.text

			setTimeout(function () {
				const $selection = $select.next('.select2-container').find('.select2-selection__rendered')
				$selection.text(truncateText(selectedText))
			}, 10)
		})

		const selectedText = $select.find('option:selected').text()
		if (selectedText) {
			const $selection = $select.next('.select2-container').find('.select2-selection__rendered')
			$selection.attr('title', selectedText)
			$selection.text(truncateText(selectedText))
		}
	}

	function initPaczkomatSelect2Truncate() {
		if (!window.matchMedia(`(max-width: 1300px)`).matches) {
			return
		}
		initSelect2Truncate()
		$(document.body).on('updated_checkout', function () {
			setTimeout(() => {
				initSelect2Truncate()
			}, 100)
			setTimeout(() => {
				$('select#paczkomat_id').trigger('select2:close')
			}, 250)
		})

		$(document).on('select2:open', function (e) {
			const $select = $(e.target)
			const selectedText = $select.find('option:selected').text()
			const $selection = $select.next('.select2-container').find('.select2-selection__rendered')
			$selection.text(selectedText)
			$(document.body).trigger('resize')
		})

		$(document).on('select2:close', function (e) {
			const $select = $(e.target)
			const selectedText = $select.find('option:selected').text()
			const $selection = $select.next('.select2-container').find('.select2-selection__rendered')
			$selection.text(truncateText(selectedText))
		})

		$(document).on('select2:select', function (e) {
			setTimeout(() => {
				const $select = $(e.target)
				const selectedText = $select.find('option:selected').text()
				const $selection = $select.next('.select2-container').find('.select2-selection__rendered')
				$selection.text(truncateText(selectedText))
			}, 10)
		})
	}

	jQuery(document).ready(function ($) {
		handleEmailSuggestionsInCheckout($)
		handleSuggestedEmailClick($)
		handleCheckoutScrollToPaymentMethod($)
		determineLayoutForVariantSelectors($)
		handleVariatnSelectorEqualHeight($)
		handleNipFieldLabelChangeInCheckout($)
		observePostsTemplateChanges(() => {})
		syncProductTabs()

		window.addEventListener('resize', function () {
			handleVariatnSelectorEqualHeight($)
		})

		$(document.body).on('show_variation', function () {
			handleVariationPriceHint($)
		})

		$(document.body).on('click', 'input.bundled_product_checkbox', toggleOptionalBundleItem)
		$(document.body).on('updated_checkout', adjustPaczkomatSelectorPosition)
		$(document.body).on('updated_checkout', adjustDPDPickupPointSelectorPosition)

		initPaczkomatSelect2Truncate()
	})

	orderAttribution()
}
